/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetOrgMembersOptions, GetOrgMembersStatus200, GetOrgMembersStatus422 } from '../models/GetOrgMembers'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getOrgMembers } from '../clients/axios/getOrgMembers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getOrgMembersQueryKey = ({ query }: Omit<GetOrgMembersOptions, 'headers'> = {}) => [{ url: '/org/members' }, ...(query ? [query] : [])] as const

type GetOrgMembersQueryKey = ReturnType<typeof getOrgMembersQueryKey>

export function getOrgMembersQueryOptions({ query }: GetOrgMembersOptions = {}, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getOrgMembersQueryKey({ query })
  return queryOptions<GetOrgMembersStatus200, ResponseErrorConfig<GetOrgMembersStatus422>, GetOrgMembersStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getOrgMembers({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @description Get all members of the org.
 * @summary Get Org Members
 * {@link /org/members}
 */
export function useGetOrgMembers<TData = GetOrgMembersStatus200, TQueryData = GetOrgMembersStatus200, TQueryKey extends QueryKey = GetOrgMembersQueryKey>({ query }: { query?: GetOrgMembersOptions['query'] | (() => GetOrgMembersOptions['query']) } = {}, options: {
  query?: Partial<QueryObserverOptions<GetOrgMembersStatus200, ResponseErrorConfig<GetOrgMembersStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getOrgMembersQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getOrgMembersQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetOrgMembersStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
